<template lang="pug">
div
  .content-center
    .modal-header.justify-content-start.align-items-center.p-2.border-bottom-0.page-title(@click="$helpers.redirect('')")
      .arrow-left
        i.fas.fa-chevron-left
      .modal-title.text-capitalize.pl-3 home
    .page-wrap.w-100
      .page-history
        .statement-body
          .tab-statement
            ul#pills-tab.nav.nav-pills.mb-3.m-0.justify-content-between.align-items-center(role="tablist")
              //- li.nav-item.col-4.px-0(role="presentation" @click="handleStatement")
              //-   a#pills-statement-tab.nav-link.text-uppercase(data-toggle="pill" href="#pills-statement" role="tab" aria-controls="pills-statement" aria-selected="true" :class="{'active' : tabTarget === 'statement'}") statement
              //- li.nav-item.col-4.px-0(role="presentation" @click="handleTransaction")
              //-   a#pills-transaction-tab.nav-link.text-uppercase(data-toggle="pill" href="#pills-transaction" role="tab" aria-controls="pills-transaction" aria-selected="false" :class="{'active' : tabTarget === 'transaction'}") transaction history
              //- li.nav-item.col-4.px-0(role="presentation" @click="handleBetHistory")
              //-   a#pills-bet-tab.nav-link.text-uppercase(data-toggle="pill" href="#pills-bet" role="tab" aria-controls="pills-bet" aria-selected="false" :class="{'active' : tabTarget === 'betHistory'}") bet history
              li.nav-item.col-4.px-0(role="presentation" @click="handleStatement")
                a#pills-statement-tab.nav-link.text-uppercase.active(data-toggle="pill" href="#pills-statement" role="tab" aria-controls="pills-statement" aria-selected="true") statement
              li.nav-item.col-4.px-0(role="presentation" @click="handleTransaction")
                a#pills-transaction-tab.nav-link.text-uppercase(data-toggle="pill" href="#pills-transaction" role="tab" aria-controls="pills-transaction" aria-selected="false") transaction history
              li.nav-item.col-4.px-0(role="presentation" @click="handleBetHistory")
                a#pills-bet-tab.nav-link.text-uppercase(data-toggle="pill" href="#pills-bet" role="tab" aria-controls="pills-bet" aria-selected="false") bet history
            .text-history(v-if="tabTarget == 'transaction'") {{ statementList.length }} {{ $t('ui.latest_transactions') }}
            #pills-tabContent.tab-content
              #pills-statement.tab-pane.fade(role="tabpanel" aria-labelledby="pills-statement-tab" :class="{'active show' : tabTarget === 'statement'}")
                .d-lg-none
                  .transaction-single.pb-2.mb-3(v-for="statement in statementList")
                    .mb-1.text-smaller {{ $moment(statement.working_date).format("YYYY-MM-DD") }}
                    .d-flex.bg-row.rounded-pill.mb-1
                      .flex-grow-1(:class="[statement.deposit_amount > 0 ? 'text-success font-weight-bold text-uppercase' : 'text-white' ]") Deposit
                      .statement-type
                        a(href="javascript:void(0);" :class="getColor(statement.deposit_amount)" @click.stop="getMemberTransferDetails(statement.working_date, statement.deposit_amount != 0);")
                          | {{ currencyCode }} {{ $numeral(statement.deposit_amount).format("0,0.00") }}
                          i.fas.fa-chevron-circle-right.ml-1(v-if="statement.deposit_amount != 0")
                    .d-flex.bg-row.rounded-pill.mb-1
                      .flex-grow-1(:class="[statement.withdrawal_amount > 0 ? 'text-success font-weight-bold text-uppercase' : 'text-white' ]") Withdrawal
                      .statement-type
                        a.font-weight-normal(href="javascript:void(0);" :class="getColor(statement.withdrawal_amount)" @click.stop="getMemberTransferDetails(statement.working_date, statement.withdrawal_amount != 0);")
                          | {{ currencyCode }} {{ $numeral(statement.withdrawal_amount).format("0,0.00") }}
                          i.fas.fa-chevron-circle-right.ml-1(v-if="statement.withdrawal_amount != 0")
                    .d-flex.bg-row.rounded-pill.mb-1
                      .flex-grow-1.text-success.font-weight-bold.text-uppercase(v-if="statement.winlose > 0") Win
                      .flex-grow-1.text-color01.font-weight-bold.text-uppercase(v-else-if="statement.winlose < 0") Lose
                      .flex-grow-1.text-white(v-else ) Win
                      .statement-type
                        a.font-weight-normal(href="javascript:void(0);" :class="getColor(statement.winlose)" @click.stop="getMemberGameResult(statement.working_date);")
                          | {{ currencyCode }} {{ $numeral(statement.winlose).format("0,0.00") }}
                          i.fas.fa-chevron-circle-right.ml-1
                    .d-flex.bg-row.rounded-pill.mb-1
                      .flex-grow-1(:class="[statement.bonus_amount > 0 ? 'text-success font-weight-bold text-uppercase' : 'text-white' ]") {{ $t("ui.promotion_bonus") }}
                      .statement-type
                        a.font-weight-normal(href="javascript:void(0);" :class="getColor(statement.bonus_amount)" @click.stop="getPromoStatement(statement.working_date);")
                          | {{ currencyCode }} {{ $numeral(statement.bonus_amount).format("0,0.00") }}
                          i.fas.fa-chevron-circle-right.ml-1
                    .d-flex.bg-row02
                      .flex-grow-1 Balance
                      .font-weight-bold
                        | {{ currencyCode }} {{ $numeral(statement.closing_balance).format("0,0.00") }}
                        i.fas.fa-chevron-circle-right.ml-1.invisible
                .d-none.d-lg-block
                  .package-table.mb-0
                    .row.table-row
                      .col-2 Date
                      .col-2 Win/Lose
                      .col-2 Deposit
                      .col-2 Withdrawal
                      .col-2 Promotion Bonus
                      .col-2 Balance
                    .row.table-row(v-for="statement in statementList")
                      .col-2 {{ $moment(statement.working_date).format("YYYY-MM-DD") }}
                      .col-2
                        .statement-type
                          a(href="javascript:void(0);" :class="getColor(statement.winlose)" @click.stop="getMemberGameResult(statement.working_date);" )
                            | {{ currencyCode }} {{ $numeral(statement.winlose).format("0,0.00") }}
                            i.fas.fa-chevron-circle-right.ml-1
                      .col-2
                        .statement-type
                          a(href="javascript:void(0);" :class="getColor(statement.deposit_amount)"  @click.stop="getMemberTransferDetails(statement.working_date, statement.deposit_amount != 0);")
                            | {{ currencyCode }} {{ $numeral(statement.deposit_amount).format("0,0.00") }}
                            i.fas.fa-chevron-circle-right.ml-1
                      .col-2
                        .statement-type
                          a(href="javascript:void(0);" :class="getColor(statement.withdrawal_amount)"  @click.stop="getMemberTransferDetails(statement.working_date, statement.withdrawal_amount != 0);")
                            | {{ currencyCode }} {{ $numeral(statement.withdrawal_amount).format("0,0.00") }}
                            i.fas.fa-chevron-circle-right.ml-1
                      .col-2
                        .statement-type
                          a(href="javascript:void(0);" :class="getColor(statement.bonus_amount)" @click.stop="getPromoStatement(statement.working_date);")
                            | {{ currencyCode }} {{ $numeral(statement.bonus_amount).format("0,0.00") }}
                            i.fas.fa-chevron-circle-right.ml-1
                      .col-2 {{ currencyCode }} {{ $numeral(statement.closing_balance).format("0,0.00") }}
              transactionHistory(v-if="tabTarget === 'transaction'" :tabTarget="tabTarget")
              betHistory(v-if="tabTarget === 'betHistory'" :tabTarget="tabTarget")
    footerInfo
</template>
<script>
import config from "@/config";
import errorTags from "@/errorTags";
import betHistory from "@/components2/_betHistory.vue"
import transactionHistory from "@/components2/_history.vue"
import footerInfo from "@/views/default/_footer.vue";
export default {
  components:{
    betHistory,
    transactionHistory,
    footerInfo
  },
  props:{
    target: {
      type: String,
      default: ""
    },
  },
  data() {
    return {
      statementList: [],
      feedback: {
        success: "",
        status: ""
      },
      tabTarget: "statement"
    };
  },
  computed: {
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    appID() {
      return config.app_id
    },
    currencyCode() {
      return this.$store.getters.currencyCode
    }
  },
  destroyed(){
    this.$store.dispatch("user/sClearHistory")
  },
  mounted(){
    if(this.target){ 
      this.tabTarget = "transaction";
      $("#pills-transaction-tab").tab('show')
    }
    this.getMemberStatement();
  },
  methods: {
    handleStatement(){
      $('#pills-statement-tab').tab('show')
      this.tabTarget = "statement"
    },
    handleBetHistory(){
      $('#pills-bet-tab').tab('show')
      this.tabTarget = "betHistory"
    },
    handleTransaction(){
      $('#pills-transaction-tab').tab('show')
      this.tabTarget = "transaction"
    },
    getColor(value) {
      if (value > 0) {
        return "text-success";
      } else if (value < 0) {
        return "text-color01";
      } else {
        return "text-white";
      }
    },
    getText(value) {
      if (value > 0) {
        return "ui.win";
      } else if (value < 0) {
        return "ui.lose";
      } else {
        return "ui.tie";
      }
    },
    getMemberTransferDetails(working_date, mode) {
      if (!mode) return
      if (this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        let app_id = this.appID
        this.$store
          .dispatch("user/getMemberTransferDetails", { account_id, working_date, auth_token, app_id })
          .then(response => {
            if (response.success == true) {
              this.$store
                .dispatch("user/sTransferDetails", response.data)
                .then(() => {
                  $("#modal-statement").modal("hide")
                  $("#modal-transfer-detail").modal("show")
                })
                .catch(err => console.log(err))
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          })
      }
    },
    getMemberGameResult(working_date, page_size, page_number) {
      if (this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        let app_id = this.appID
        this.$store
          .dispatch("user/getMemberGameResult", { account_id, working_date, page_size, page_number, auth_token, app_id })
          .then(response => {
            if (response.success == true) {
              this.$store
                .dispatch("user/sBetHistory", { data: response.data, size: 10, index: 1, working_date: working_date })
                .then(() => {
                  this.tabTarget = "betHistory";
                  $('#pills-bet-tab').tab('show')
                })
                .catch(err => console.log(err))
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          })
      }
    },
    getMemberStatement() {
      if (this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        let app_id = this.appID
        this.$store
          .dispatch("user/getMemberStatement", { account_id, auth_token, app_id })
          .then(response => {
            if (response.success == true) {
              this.statementList = response.data
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          })
      }
    },
    getPromoStatement(working_date) {
      if (this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        let app_id = this.appID
        this.$store
          .dispatch("user/getPromoStatement", { account_id, working_date, auth_token, app_id })
          .then(response => {
            if (response.success == true) {
              this.$store
                .dispatch("user/sPromoDetails", response.data)
                .then(() => {
                  $("#modal-statement").modal("hide")
                  $("#modal-promo-statement").modal("show")
                })
                .catch(err => console.log(err))
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          })
      }
    }
  }
}
</script>